import { useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

import useCreateEngine from './queries/useCreateEngine';

import FormBase from '@/components/forms/new/FormBase';
import Alert from 'components/v4/Alert';
import AlertDescription from 'components/v4/AlertDescription';
import AlertIcon from 'components/v4/AlertIcon';
import {
    breadCrumbTrail,
    addHeader as header,
    initialState,
    enginesPath,
} from './constants';
import { engineSchema } from './schema';
import EngineNameField from './formFields/EngineNameField';

const EnginesAdd = () => {
    const navigate = useNavigate();
    const { darkMode } = useSelector((state) => state.settings);
    const [error, setError] = useState(null);

    const handleSuccess = () => {
        toast.success('Engine created successfully!');
        navigate(enginesPath);
    };

    const handleError = (err) => {
        console.error('Failed to create engine:', err);
        setError(
            err?.response?.data?.message ||
                'Failed to create engine. Please try again.',
        );
    };

    const { mutate: createEngine, isPending } = useCreateEngine(
        handleSuccess,
        handleError,
    );

    const finalFormSubmit = async (values) => {
        setError(null);

        let validated;
        try {
            validated = await engineSchema.validate(values);
        } catch (validationError) {
            setError(validationError.message);
            return;
        }

        createEngine({
            name: validated.name,
        });
    };

    const formFields = (errors, touched) =>
        [
            <EngineNameField
                key="name"
                errors={errors}
                touched={touched}
                darkMode={darkMode}
            />,
            error && (
                <Alert key="error" status="error" sx={{ margin: '25px 0' }}>
                    <AlertIcon />
                    <AlertDescription>{error}</AlertDescription>
                </Alert>
            ),
        ].filter(Boolean);

    return (
        <FormBase
            isSubmitDisabled={isPending}
            isLoading={isPending}
            breadCrumbTrail={breadCrumbTrail}
            header={header}
            initialValues={initialState}
            finalFormSubmit={finalFormSubmit}
            backLink={[enginesPath, { state: { index: 0 } }]}>
            {({ errors, touched }) => formFields(errors, touched)}
        </FormBase>
    );
};

export default EnginesAdd;
